module.exports = __webpack_public_path__ + "static/media/bill2.eafc26fe.jpg";